class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('[data-predictive-search]');
    this.abortController = null;
    this.cachedQuery = '';
    this.debounceTimer = null;
  }

  connectedCallback() {
    if (!this.input || !this.resultsContainer) return;

    this.input.addEventListener('input', this.onChange.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  onChange() {
    const query = this.input.value.trim();

    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(() => {
      if (!query.length) {
        this.close();
        return;
      }
      this.getSearchResults(query);
    }, 180);
  }

  onFocus() {
    const query = this.input.value.trim();
    if (query.length && this.resultsContainer.innerHTML.trim() !== '') {
      this.open();
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.input.blur();
    }
  }

  getSearchResults(query) {
    if (query === this.cachedQuery) {
      this.open();
      return;
    }

    this.cachedQuery = query;

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    const url =
      `${window.Shopify.routes.root}search/suggest` +
      `?q=${encodeURIComponent(query)}` +
      `&resources[type]=product,collection,page,article` +
      `&resources[limit]=4` +
      `&section_id=pf-predictive-search`;

    fetch(url, {
      signal: this.abortController.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => response.text())
      .then((markup) => {
        const html = new DOMParser().parseFromString(markup, 'text/html');
        const content = html.body.innerHTML.trim();

        if (!content) {
          this.close();
          return;
        }

        this.resultsContainer.innerHTML = content;
        this.open();
      })
      .catch(() => {});
  }

  open() {
    this.resultsContainer.classList.add('is-open');
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.resultsContainer.classList.remove('is-open');
    this.input.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.pf-header');
  const toggle = document.querySelector('.pf-header__mobile-toggle');
  const drawer = document.querySelector('.pf-mobile-drawer');

  if (toggle && drawer) {
    const closeDrawer = () => {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pf-mobile-drawer-open');
    };

    const openDrawer = () => {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('pf-mobile-drawer-open');
    };

    toggle.addEventListener('click', () => {
      if (drawer.hidden) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });

    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
      el.addEventListener('click', closeDrawer);
    });
  }

  if (header && header.classList.contains('pf-header--sticky-enabled')) {
    const onScroll = () => {
      if (window.scrollY > 8) {
        header.classList.add('is-stuck');
      } else {
        header.classList.remove('is-stuck');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
});